import { render, staticRenderFns } from "./NoticeSendDialog.vue?vue&type=template&id=04734b5a&scoped=true&"
import script from "./NoticeSendDialog.vue?vue&type=script&lang=js&"
export * from "./NoticeSendDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04734b5a",
  null
  
)

export default component.exports